import { logEvent } from 'firebase/analytics';
import { analyticsPromise } from './firebase';

// Fire-and-forget GA4 event logging. Must never throw into caller code — an
// ad-blocked script or unsupported browser shouldn't break the booking/payment flow.
export const trackEvent = (eventName, params = {}) => {
  analyticsPromise
    .then((analytics) => {
      if (analytics) logEvent(analytics, eventName, params);
    })
    .catch(() => {});
};

// react-router SPA navigations don't trigger new page loads, so GA4's automatic
// page_view (which only fires once, on initial script load) misses every route change.
export const trackPageView = (path) => {
  trackEvent('page_view', {
    page_path: path,
    page_title: document.title,
    page_location: window.location.href,
  });
};
